var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-config-page page-content"},[_c('h4',[_vm._v("Configuración Cliente")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }